import * as types from '../action-types';
import { ActionSidebarSummaryReducerType } from '../decisionState.types';
import { ActionSidebarSummaryActions } from '../actions';

const initialState: ActionSidebarSummaryReducerType = {
  isOpen: false,
  top: -9999,
  left: 0,
};

export function actionSidebarSummaryReducer(
  state: ActionSidebarSummaryReducerType = initialState,
  action: ActionSidebarSummaryActions,
) {
  switch (action.type) {
    case types.openActionSidebarSummaryPopover: {
      const { data } = action.payload;
      return { ...state, isOpen: true, ...data };
    }
    case types.closeActionSidebarSummaryPopover: {
      return {
        ...state,
        isOpen: false,
        top: -9999,
      };
    }
    default: {
      return state;
    }
  }
}
